import { create } from "zustand";
import { persist } from "zustand/middleware";

export type DealsView = "table" | "kanban";

export type SortField =
  | "lastActivity"
  | "name"
  | "fitScore"
  | "gapAnalysis"
  | "added"
  | "status";

export type SortDirection = "asc" | "desc";

export interface SortConfig {
  field: SortField;
  direction: SortDirection;
}

interface DealsViewStore {
  view: DealsView;
  sort: SortConfig;
  setView: (view: DealsView) => void;
  setSort: (sort: SortConfig) => void;
  toggleSortDirection: () => void;
}

const DEFAULT_SORT: SortConfig = { field: "lastActivity", direction: "desc" };

export const useDealsViewStore = create<DealsViewStore>()(
  persist(
    (set) => ({
      view: "table",
      sort: DEFAULT_SORT,
      setView: (view) => set({ view }),
      setSort: (sort) => set({ sort }),
      toggleSortDirection: () =>
        set((state) => ({
          sort: {
            ...state.sort,
            direction: state.sort.direction === "asc" ? "desc" : "asc",
          },
        })),
    }),
    {
      name: "deals-view-pref",
      version: 1,
      migrate: (persistedState: unknown, _version: number) => {
        if (persistedState && typeof persistedState === "object") {
          const state = persistedState as Partial<DealsViewStore>;
          if (!state.sort) {
            return { ...state, sort: DEFAULT_SORT };
          }
        }
        return persistedState;
      },
    }
  )
);
